<template>

    <div class="pagination">
        <a class="pagination-item" :class="{ disabled: this.page === 1 }" href="#" @click.prevent="paginateFirst">
            <i class="icon fas fa-angle-double-left"></i>
        </a>
        <a class="pagination-item" :class="{ disabled: this.page === 1 }" href="#" @click.prevent="paginateBack">
            <i class="icon fas fa-angle-left"></i>
        </a>
        <a class="pagination-item" :class="{ disabled: this.page === this.count }" href="#" @click.prevent="paginateNext">
            <i class="icon fas fa-angle-right"></i>
        </a>
        <a class="pagination-item" :class="{ disabled: this.page === this.count }" href="#" @click.prevent="paginateLast">
           <i class="icon fas fa-angle-double-right"></i>
        </a>
    </div>

</template>

<style lang="scss">

    .pagination {
        border: 1px solid $color-rule;
        border-radius: 3px;
        display: flex;
        .pagination-item {
            align-items: center;
            border-left: 1px solid $color-rule;
            color: $color-text;
            display: flex;
            font-size: 12px;
            justify-content: center;
            height: 40px;
            text-decoration: none;
            transition: .3s background-color;
            width: 40px;
            &.disabled .icon {
                opacity: 0.5;
            }
            &:first-child {
                border: none;
            }
            &:hover {
                background-color: $color-bg;
            }
        }
    }

</style>

<script>

export default {

    props: {
        count: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        }
    },

    methods: {

        paginateFirst() {
            this.page = 1;
            this.$emit('search', this.page);
        },

        paginateBack() {
            this.page = Math.max(1, this.page - 1);
            this.$emit('search', this.page);
        },

        paginateNext() {
            this.page = Math.min(this.page + 1, this.count);
            this.$emit('search', this.page);
        },

        paginateLast() {
            this.page = this.count;
            this.$emit('search', this.page);
        },

    },

}

</script>